module.exports = __webpack_public_path__ + "img/close-up-raspberries-smoothie.f9d6196f.jpg";